import { render, staticRenderFns } from "./promocode-add.vue?vue&type=template&id=baeed7f4"
import script from "./promocode-add.vue?vue&type=script&lang=js"
export * from "./promocode-add.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports